import { makeAutoObservable } from "mobx";

export interface HorizonConfirmContext {
  /** The out-of-horizon target date being scheduled to. */
  date: Date | string;
  /** The configured horizon date (for the message). */
  horizonDate: Date | string | null;
  /** What is being scheduled — tunes the wording. */
  kind?: "appointment" | "event";
}

/**
 * Global, promise-based confirmation shown when the user schedules or moves a
 * treatment / event time slot PAST the planning horizon. Scheduling beyond the
 * horizon is not forbidden outright — it is a soft block: the user must confirm.
 *
 * `requestConfirm` opens the dialog and resolves to `true` (proceed) or `false`
 * (cancel). Singleton, mirroring the doctor↔clinic join prompt pattern.
 */
class HorizonConfirmStore {
  open = false;
  context: HorizonConfirmContext | null = null;
  resolver: ((confirmed: boolean) => void) | null = null;

  constructor() {
    makeAutoObservable(this, { resolver: false });
  }

  requestConfirm(context: HorizonConfirmContext): Promise<boolean> {
    this.context = context;
    this.open = true;
    return new Promise<boolean>((resolve) => {
      this.resolver = resolve;
    });
  }

  private settle(confirmed: boolean) {
    const resolve = this.resolver;
    this.resolver = null;
    this.context = null;
    this.open = false;
    resolve?.(confirmed);
  }

  confirm() {
    this.settle(true);
  }

  cancel() {
    this.settle(false);
  }
}

const horizonConfirmStore = new HorizonConfirmStore();
export default horizonConfirmStore;
